import { LinearProgress, linearProgressClasses } from "@mui/material";
import { toNumber } from "lib/math";
import React from "react";
import { PRIMARY_COLOR } from "theme/variable";
import CustomText from "./typography/CustomText";
import { styled } from "@mui/material/styles";

export const SimpleProgressBar = styled(LinearProgress)(
  ({ theme, color, height }) => ({
    height: height,
    borderRadius: theme.shape.borderRadius,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette?.[color]?.main ?? PRIMARY_COLOR,
    },
  })
);

export default function CustomProgressBar({
  progressType = "",
  variant = "striped",
  label = "",
  value = 50,
  color = "primary",
  size = "",
  height = 8,
}) {
  value = toNumber(value);
  return variant === "striped" ? (
    <div
      className={`progress progress-striped active rounded progress-${size}`}
    >
      <div
        style={{ width: `${value}%` }}
        className={`progress-bar bg-${color} rounded text-right`}
      >
        <CustomText
          className={`${
            value < 80 ? "transform translate-x-full" : ""
          } whitespace-nowrap ml-4`}
          bold={600}
          color="secondary"
          component="span"
        >
          {Boolean(label)
            ? Boolean(progressType)
              ? Boolean(value)
                ? label
                : ""
              : label
            : `${value}%`}
        </CustomText>
      </div>
    </div>
  ) : (
    <SimpleProgressBar variant="determinate" value={value} height={height} />
  );
}
